export enum EventTypeFilter {
  ALL = "ALL",
  NOTIFICATION = "NOTIFICATION",
  ALERT = "ALERT",
}

export enum ReadStatusFilter {
  ALL = "ALL",
  READ = "READ",
  UNREAD = "UNREAD",
}

export enum EventType {
  ALERT = "ALERT",
  NOTIFICATION = "NOTIFICATION",
}

export enum RealtimeEventType {
  RESOLVE_ALERT = "RESOLVE_ALERT",
}

export interface GetEventsRequest {
  dealerIds: string[];
  eventType: EventTypeFilter;
  readStatus: ReadStatusFilter;
}

export interface GetDealerAndUserScopedEventsRequest {
  dealerIds: string[];
  eventType: EventTypeFilter;
  readStatus: ReadStatusFilter;
  userScopedCategories: string[];
}

export interface PatchEventRequest {
  id: string;
  type: EventTypeFilter;
  timestamp: string;
  dealerId: string;
}

export interface PatchEventResponse {
  status: string;
  message: string;
}

export interface GetEventsResponse {
  id: string;
  type: EventType;
  category: string;
  payload: Object;
  dealerId: string;
  userId: string;
  readStatus: boolean;
  timestamp: string;
}

export interface BroadcastMessageAttachment {
  id: string;
  filename: string;
  fileSize: number;
}

export interface BroadcastMessageAttachmentUrl {
  id: string;
  filename: string;
  url: string;
}

export interface BroadcastMessagePayload {
  msgId: string;
  parentMsgId: string;
  title: string;
  content: string;
  tag: string;
  url: string;
  userGroup: string;
  userGroupValues: string[];
  validFrom: string;
  validTo: string;
  attachments: BroadcastMessageAttachment[];
  attachmentUrls: BroadcastMessageAttachmentUrl[];
}

export interface ResolveAlertEvent {
  id: string;
  type: EventType;
  realtimeEventType: RealtimeEventType;
  userId: string;
  dealerId: string;
  timestamp: string;
}

export interface CreateChannelRequest {
  accountIds: string[];
}

export interface CreateChannelResponse {
  status: string;
  message: string;
  ttl: number;
}

export interface PatchChannelResponse {
  status: string;
  message: string;
  ttl: number;
}

export interface AppNotificationsApi {
  getAllEvents: (request: GetEventsRequest) => Promise<GetEventsResponse[]>;
  getDealerAndUserScopedEvents: (
    request: GetDealerAndUserScopedEventsRequest
  ) => Promise<GetEventsResponse[]>;
  markEventsAsRead: (
    request: PatchEventRequest[]
  ) => Promise<PatchEventResponse>;
  createChannel: (
    request: CreateChannelRequest
  ) => Promise<CreateChannelResponse>;
  keepChannelAlive: () => Promise<PatchChannelResponse>;
}
